import React, { Fragment, useContext, useEffect, useState } from "react";
import { AppContext } from "../../components/AppProvider";
import { _O } from "../../modules/utils";
import { setCookie } from "../../modules/utils/cookie";
import { IC } from "../../resources/Assets";
import AuthAgreement from "../Company/TermsDetail/AuthAgreement";
import TermsPopup from "../Company/TermsDetail/TermsPopup";
import TermsViewer from "../Company/TermsDetail/TermsViewer";
import { Container, InputPopup, openLayerFn } from "../Layout";

export default (props) => {

    const { cfg, auth , dispatch,  phonecfg, userinfo } = useContext(AppContext);
    
    const [loginSuccess, setLoginSuccess] = useState(false);
    const [isAutoLogin, setIsAutoLogin] = useState(true);
    const [dupList, setDupList] = useState('');
    const [attctNo, setAttctNo] = useState('');
    const [joinInfo, setJoinInfo] = useState({});

    // 다이얼로그 [[
    const [dialog, setDialog] = useState({
        title: '',
        msg: ''
    })

    const handleConfirm = (title, msg) => {
        setDialog({
            title: title,
            msg: msg
        })

        openLayerFn($(".confirm-layer"));
    }

    const registToAttctNo = (attctNoParam) => {
        let attctNoVal = '';

        if(attctNoParam) {
            attctNoVal = attctNoParam;
        } else {
            attctNoVal = attctNo;
        }

        if(attctNoParam != 0) {
            // 인증번호 확인
            PostApi1930(userinfo, cfg, phonecfg, "N", attctNoVal)
            .then(res => {
                    if (res.resultCode === '000') {
                        setJoinInfo(res.joinInfo);
                        closeLayerFn($("#inputPopup"));
                        openLayerFn($("#termsPopup"));
                        attctNoVal = '';
                    } else if(res.resultCode === '003') {
                        setDupList(res.loginInfo);
                        openLayerFn($("#existLayer"));
                    } else if(res.resultCode === '004') {
                        setLoginSuccess(true);
                        handleLoginSuccess500(res);

                        setTimeout(() => {
                            socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {"login":"in", "userToken":res.resultList[0].userToken.toString()});
                        }, 2000)
                    } else {
                        openAlertPopup("인증번호를 확인하세요.");
                    }

            })
            .catch(err => {
                console.log(err);
            });
        } else {
            // 인증번호 가입
            PostApi1931(userinfo, cfg, phonecfg, attctNoVal, joinInfo)
            .then(res => {
                if(res.resultMsg === 'SUCCESS') {
                    // alert("연동에 성공하였습니다.");
                    // handleConfirm("", "연동에 성공하였습니다.")

                    if (res.resultCode === '000') {
                        setLoginSuccess(true);
                        handleLoginSuccess500(res);

                        setTimeout(() => {
                            socketManager(SocketCommand.UPDATE_PHONE_USER_INFO, undefined, {"login":"in", "userToken":res.loginInfo[0].userToken.toString()});
                        }, 2000)
                    } else {
                        handleConfirm("", "로그인 실패");
                    }

                } else {
                    openAlertPopup("인증번호 등록에 실패하였습니다.");
                }
            })
            .catch(err => {
                console.log(err);
            });
        }
    }

    const termsAfterAction = () => {
        // _O.Open("/membership/help/vrfcn/0/green/certi");
        _O.Open('/cnntHspt/0');
    }

    useEffect(() => {
        setCookie('signUpChannel', '500', 1);
    }, [])

    return(
        <Fragment>
            <Container dark={'dark'} isMain={false} goToUrl="/membership/login">
                <div className="contents">
                    <div className="sub-contents">

                        <div className="first-visit-container">

                            {
                                props.match.params.step === "1" 
                                    &&  <>
                                            <VisitCardMenu color="green" type="0" />
                                            <VisitCardMenu color="purple" type="1" />
                                        </>
                            }
                            {
                                props.match.params.step === "2" 
                                    &&  <>
                                            <VisitCardMenu color="green" type="2" />
                                            <VisitCardMenu color="purple" type="3" />
                                        </>
                            }
                            

                        </div>

                    </div>
                </div>
            </Container>
            <InputPopup handleConfirm={handleConfirm} registToAttctNo={registToAttctNo} setAttctNo={setAttctNo} />
            <TermsPopup />
            <TermsViewer />
            <AuthAgreement registToAttctNo={termsAfterAction} />
        </Fragment>
    );
}

export const VisitCardMenu = (props) => {

    const { color, type } = props;

    const option = [
        {
            "url":"/membership/help/vrfcn/0/green/certi",
            "image": IC.etc.visit01,
            "text": <>케어포미를 <br /> <em> 처음 사용하나요? </em></>
        },
        {
            "url":"/membership/help/2",
            "image": IC.etc.visit02,
            "text": <>케어포미를 <br /> <em> 사용한 적이 있나요? </em></>
        },
        {
            // "url":"/membership/help/vrfcn/0/green/certi",
            "url":"/cnntHspt/2",
            "image": IC.etc.visit03,
            "text": <>현재 계신 곳이 <br /> <em> 병원 내부</em>인가요?</>
        },
        {
            "url":"/membership/help/vrfcn/0/purple/SMS",
            "image": IC.etc.visit04,
            "text": <>현재 계신 곳이 <br /> <em> 병원 외부</em>인가요?</>
        }
    ]

    const cardClickEvent = (type) => {
        if(type === "0") {
            openLayerFn($("#termsPopup"));
        } else {
            _O.Open(option[type].url);
        }
    }

    return(
        <div className={"card " + color} onClick={()=>cardClickEvent(type)}>
            <div>
                <a>
                    <div className="card-imgbox">
                        <img src={option[type].image} alt="" />
                    </div>
                    
                    <div className="card-txt">
                        <div>
                            {/* 케어포미를 <br /><em>처음 사용하나요?</em> */}
                            {option[type].text}
                        </div>
                    </div>
                </a>
            </div>
        </div>
    );
}